// Autogenerated file
export const waybillStateFlagsEnum = {
    ChangeTitleRequired: "ChangeTitleRequired",
    QrRequestRequired: "QrRequestRequired",
    HasExternalRevisions: "HasExternalRevisions",
    Archived: "Archived",
    HasPartialDelivery: "HasPartialDelivery",
    HasRejectedDelivery: "HasRejectedDelivery",
};
export const waybillStateFlags = [
    { label: "Требуется формирование Т8 ЭТрН", value: "ChangeTitleRequired", intValue: 1 },
    { label: "Требуется получение QR-кода", value: "QrRequestRequired", intValue: 2 },
    { label: "У ЭТрН появилось исправление титула, которое требуется подписать на стороне оператора ЭДО", value: "HasExternalRevisions", intValue: 4 },
    { label: "ЭТрН находится в архиве", value: "Archived", intValue: 8 },
    { label: "Частичная приёмка груза", value: "HasPartialDelivery", intValue: 16 },
    { label: "Отказ от приёмки груза", value: "HasRejectedDelivery", intValue: 32 },
];
